(function () {
    // save the section id from the script tag and find the section
    const sectionID = document.currentScript.dataset.id;
    const section = document.querySelector(`#${sectionID}`);

    // exit if section is not found
    if (!section) {
        console.warn(`Product section with ID ${sectionID} not found.`);
        return;
    }

    // get the key values from the section
    const product = JSON.parse(section.querySelector(".productJSON").textContent);
    let activeVariant = JSON.parse(section.querySelector(".productVariantJSON").textContent);

    // during dev mode, set the active variant to the window so it can be accessed in the console
    if (Shopify.theme.role === "development") {
        window.product = product;
        window.activeVariant = activeVariant;
    }

    /************
     Product Swiper
     ************/

    const thumbsSwiper = new Swiper(section.querySelector(".productVisualThumbs"), {
        slidesPerView: 5,
        spaceBetween: 6,
    })

    const productSwiper = new Swiper(section.querySelector(".productVisualSwiper"), {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: true,
        autoHeight: true,
        navigation: {
            nextEl: section.querySelector(".productVisualSwiperNext"),
            prevEl: section.querySelector(".productVisualSwiperPrev"),
        },
        thumbs: {
            swiper: thumbsSwiper,
        },
        // pinch or double tap to zoom, swiper blocks the browser's own pinch zoom on the slider
        zoom: {
            maxRatio: 3,
        },
        on: {
            slideChange: function () {
                if (!section.querySelector(".productVisualSwiperSlide")) {
                    return;
                }

                // pause all videos
                section.querySelectorAll(".productVisualSwiperSlide video").forEach(element => {
                    element.pause();
                });
            },
            zoomChange: function (swiper, scale, imageElement) {
                // swap in the large image the first time it's zoomed
                if (scale <= 1 || !imageElement.dataset.zoomSrc) {
                    return;
                }

                imageElement.src = imageElement.dataset.zoomSrc;
                delete imageElement.dataset.zoomSrc;
            }
        }
    });

    // play video on slide play click
    section.querySelectorAll(".productVisualSwiperSlide").forEach(element => {
        element.addEventListener("click", function () {
            // get video
            const video = this.closest(".productVisualSwiperSlide").querySelector("video");

            if (!video) {
                return;
            }

            // remove play button if it hasn't already been removed
            this.querySelector(".productVisualSwiperSlidePlay")?.remove();

            // show controls
            video.controls = true;

            // play video
            video.play();
        });
    });

    /**************
     Update Product
     ***************/

    // update active variant on input changes
    section.querySelectorAll("input, select").forEach(function (element) {
        element.addEventListener("change", function () {
            // if there is a bundle product, reveal box contents
            if (this.classList.contains('productOptionsItemValues')) {
                if (section.querySelector('.productOptionsBundle')) {
                    section.querySelector('.productOptionsBundle')?.classList.add('active');
                    // if the information is variant level, show correct info
                    if (section.querySelector('.productOptionsBundleList.group')) {
                        section.querySelectorAll('.productOptionsBundleList').forEach(el => {
                            el.dataset.value === this.value ? el.classList.add('active') : el.classList.remove('active');
                        })
                    }
                }
            }
            updateProduct().catch(e => console.error(e));
        });
    })

    async function updateProduct() {
        // if no atc button - out of stock
        if (!section.querySelector(".productOptionsBottomATC")) return;
        // Find the active variant
        if (product.variants.length === 1) {
            // default fallback
            activeVariant = product.variants[0];
        } else {
            // collect options from inputs
            let options = [];
            section.querySelectorAll(`.productOptionsItem`).forEach(group => {
                options.push(group.querySelector(`select`).value);
            });

            // find new variant based on the options
            activeVariant = product.variants.find((variant) => {
                return JSON.stringify(variant.options) === JSON.stringify(options)
            });
        }

        // check if variant wasn't found
        if (!activeVariant) {
            section.querySelector(".productOptionsBottomATC").disabled = true;
            section.querySelector(".productOptionsBottomATC").textContent = "Not Available";
            return;
        }

        // update SKU if available
        if (activeVariant.sku && section.querySelector(".productSku")) {
            section.querySelectorAll(".productSku").forEach(el => el.textContent = activeVariant.sku);
        }

        /**************
         Variant Image
         ***************/

        if (activeVariant.featured_image) {
            // change active slide
            productSwiper.slideTo(activeVariant.featured_image.position - 1);
        }

        /**************
         Price
         ***************/

        // update price
        section.querySelectorAll('.productPriceCompare').forEach(element => {
            element.textContent = "";
        })
        if (activeVariant.compare_at_price > activeVariant.price) {
            section.querySelectorAll('.productPriceCompare').forEach(element => {
                element.textContent = price(activeVariant.compare_at_price);
            })
        }
        section.querySelectorAll('.productPriceActual').forEach(element => {
            element.textContent = price(activeVariant.price);
        })

        // savings
        let savings = activeVariant.compare_at_price - activeVariant.price;
        section.querySelectorAll('.productNotice').forEach(element => {
            element.textContent = ``;
        })
        if (savings > 0) {
            section.querySelectorAll('.productNotice').forEach(element => {
                element.textContent = `Save ${price(savings)}`;
            })
        }

        // if discount pill, show the price at checkout
        if (section.querySelector('.productDiscountTextAmount') && section.querySelector('.productDiscountTextAmount').dataset.percent) {
            const salePrice = activeVariant.price - (activeVariant.price * parseInt(section.querySelector('.productDiscountTextAmount').dataset.percent) / 100)
            section.querySelectorAll('.productDiscountTextAmount').forEach(el => el.textContent = price(salePrice));
        }

        // if bnpl, update the prices on variant change these elements offer four payments plan
        section.querySelectorAll('.productBNPLPayments')?.forEach(element => {
            element.classList.contains('productBNPLPaymentsMonthly')
                ? element.textContent = price(activeVariant.price / 6)
                : element.textContent = price(activeVariant.price / 4);
        })

        /**************
         ATC Enable/Disable
         ***************/

        // check if the variant is in stock
        if (activeVariant.available) {
            section.querySelector(".productOptionsBottomATC").disabled = false;
            section.querySelector(".productOptionsBottomATC").textContent = section.querySelector(".productOptionsBottomATC")?.dataset?.text || 'Add To Cart';
        } else {
            section.querySelector(".productOptionsBottomATC").disabled = true;
            section.querySelector(".productOptionsBottomATC").textContent = "Sold Out";
        }

        /*************
         Update Sticky
         *********/

            // update url with variant id so the selected options are maintained on refresh
        let url = new URL(window.location.href);
        url.searchParams.set("variant", activeVariant.id);
        window.history.replaceState({}, "", url);
    }

    // on load, update the product
    // this accomplishes loading the correct variant image and price on page load
    updateProduct().catch(e => console.error(e));

    /************
     Product ATC
     ************/

    async function addToCart(properties = {}) {

        // if there is an embed form, stop and allow form to gather info
        if (section.querySelector('.productOptionsForm')) {
            document.querySelector('body').classList.add('noScroll');
            section.querySelector('.productOptionsForm').showModal();
            return;
        }

        // if there is a mask option, we need to ensure the steps have been completed
        // unsure choice on any option will trigger required information for order - phone number
        let unsure = false;
        let unsureProperties = {};
        // mask item to add
        let maskItem = {};
        let decline = true;
        if (maskOption) {
            if (section.querySelector('.productMaskChoiceInput:checked')?.value !== "decline") {
                // mark accepted to add
                decline = false;
                section.querySelectorAll('.productMaskTypeProductsItemInput:checked,.productMaskSelectItem.active .productMaskSelectChoice,.productMaskSizeChoice')?.forEach(el => {
                    if (el.value === "unsure") {
                        unsure = true
                    }
                })
                if (unsure) {
                    const phoneNumber = section.querySelector('.productMaskStepInput[name="phone"]').value;
                    if (phoneNumber === "") {
                        section.querySelector('.productOptionsBottomWarning').textContent = "Please enter you contact information";
                        addWarning();
                        return;
                    }
                    unsureProperties = {
                        unsure: "Unsure of mask choice",
                        phone_number: phoneNumber,
                        notes: section.querySelector('.productMaskStepInput[name="notes"]')?.value || ""
                    }
                } else {
                    const maskId = section.querySelector('.productMaskSizeChoice')?.value;
                    if (maskId) {
                        maskItem = {
                            quantity: 1,
                            id: maskId,
                        }
                    } else {
                        addWarning();
                        return;
                    }
                }
            }
        }

        // add loading animation to both buttons
        section.querySelector(".productOptionsBottomATC").classList.add("loading");

        let formData = {
            items: [{
                quantity: 1,
                id: activeVariant.id,
                properties: properties
            }]
        };

        // if mask option added, add the mask or the unsure information
        if (maskOption && !decline) {
            if (unsure) {
                formData.items[0].properties = {
                    ...properties,
                    ...unsureProperties
                };
            } else {
                formData.items.push(maskItem)
            }
        }

        // check for and remove any unwanted property items
        if (formData.items[0]?.properties) {
            delete formData.items[0].properties.isTrusted;
        }

        // check if there is a companion item
        if (section.querySelector('.productOptionsCompanionContentInput')) {
            section.querySelectorAll('.productOptionsCompanionContentInput').forEach(el => {
                if (el.checked) {
                    formData.items.push({
                        quantity: 1,
                        id: el.value,
                    })
                }
            })
        }

        // add product
        await addProduct(formData);

        // remove loading animation
        section.querySelector(".productOptionsBottomATC").classList.remove("loading");

        // open cart
        await openCart();
    }

    // shows warning and adds animation to text
    function addWarning() {
        section.querySelector('.productOptionsBottomWarning').classList.add('active');
        section.querySelector('.productOptionsBottomWarning').classList.add('shake');
        setTimeout(() => {
            section.querySelector('.productOptionsBottomWarning').classList.remove('shake');
        }, 300)
    }

    // if there is a form, set up dialog and add listener to gather data
    if (section.querySelector('.productOptionsForm')) {
        section.querySelector('.productOptionsForm').addEventListener('close', () => document.querySelector('body').classList.remove('noScroll'));
        section.querySelector('.productOptionsForm').addEventListener('click', function (e) {
            if (e.target === this) this.close();
        });
        section.querySelector('.productOptionsFormExit').addEventListener('click', () => section.querySelector('.productOptionsForm').close());

        // when form loads, add listeners and remove observer
        function waitForProductForm(section) {
            const observer = new MutationObserver((mutations, obs) => {
                const wrapper = section.querySelector('.productOptionsForm');
                const form = wrapper?.querySelector('form');
                if (form) {
                    obs.disconnect();
                    gatherCustomData(form);
                }
            });

            observer.observe(section, {
                childList: true,
                subtree: true
            });
        }

        // add listener for form submit
        function gatherCustomData(form) {
            form.addEventListener('submit', async function (e) {
                // get value to add as properties to cart
                const data = {};
                this.querySelectorAll('input').forEach(el => {
                    if (el.type === 'radio' && !el.checked) return;
                    data["_" + el.name] = el.value;
                });
                data["_form"] = "true";
                // close and remove form
                section.querySelector('.productOptionsForm').close();
                section.querySelector('.productOptionsForm').remove();
                await addToCart(data);
            })
        }

        // on load begin watching for form
        waitForProductForm(section);
    }

    section.querySelector('.productOptionsBottomATC')?.addEventListener("click", () => addToCart());

    /**********************
     Mask Option - machines
     ***********************/

        // mask swiper - used for mask stages and masks on bundle pages
    const maskInfoSwiper = new Swiper(section.querySelector(".productSlideInfoSwiper"), {
            slidesPerView: 1,
            spaceBetween: 20,
            autoHeight: true
        });

    // zoom button on the mask swiper
    section.querySelector('.productSlideInfoSwiperZoom')?.addEventListener('click', function () {
        // find source of selected slide
        const src = maskInfoSwiper.slides[maskInfoSwiper.activeIndex].querySelector('img')?.src;
        // if no source, do nothing
        if (src) {
            openImageDialog(src);
        }
    })

    // populating the mask info slide out
    function maskInfoSlideIn(mask) {
        // change info in the mask info slide out
        // title
        section.querySelector('.productSlideInfoTitle').textContent = mask.title;
        // images
        // clear the slides and thumbs
        section.querySelector('.productSlideInfoSwiperWrapper').innerHTML = "";
        section.querySelector('.productSlideInfoThumbs').innerHTML = "";
        for (let i = 0; i < mask.images.length; i++) {
            section.querySelector('.productSlideInfoSwiperWrapper').insertAdjacentHTML("beforeend", `
                                <div class="swiper-slide">
                                    <img class="productSlideInfoSwiperWrapperImage"
                                        src="${mask.images[i]}&width=600"
                                        alt="${mask.title}"/>
                                </div>
                            `)
            section.querySelector('.productSlideInfoThumbs').insertAdjacentHTML("beforeend", `
                               <button class="productSlideInfoThumbsItem" data-index="${i}"
                                    title="select slideshow image" aria-label="select image button">
                                    <img src="${mask.images[i]}&width=100"
                                         alt="${mask.title}"/>
                                </button>
                            `)
        }
        // update the swiper
        maskInfoSwiper.update();
        // event listeners on thumbs
        section.querySelectorAll('.productSlideInfoThumbsItem')?.forEach(item => {
            item.addEventListener('click', function () {
                // change slide
                maskInfoSwiper.slideTo(this.dataset.index);
            })
        })
        // content
        if (mask.metadata.info) {
            section.querySelector('.productSlideInfoContent').innerHTML = mask.metadata.info;
        } else {
            section.querySelector('.productSlideInfoContent').innerHTML = mask.description;
        }
        // note
        if (mask.metadata.note) {
            section.querySelector('.productSlideInfoContentNote').innerHTML = mask.metadata.note;
        }
        // url
        section.querySelector('.productSlideInfoContentURL').href = mask.url;
    }

    // is there a mask selection on this product?
    const maskOption = section.querySelector('.productMask')
    // stages of mask selection
    if (maskOption) {

        // collection of steps
        let firstSelected = true;
        // open stage
        section.querySelectorAll('.productMaskChoiceInput')?.forEach(input => {
            input.addEventListener('change', function () {
                // if decline chosen, hide all steps
                if (this.value === 'decline') {
                    section.querySelectorAll('.productMaskStep').forEach(el => el.classList.remove('active'));
                } else {
                    section.querySelector('.productMaskStep').classList.add('active');
                    // change warning message next to atc if first time
                    if (firstSelected) {
                        section.querySelector('.productOptionsBottomWarning').textContent = "Choose Mask Type"
                        firstSelected = false;
                    }
                }
            })
        })

        // mask category selection
        section.querySelectorAll('.productMaskTypeProductsItemInput')?.forEach(el => {
            el.addEventListener('change', function () {
                // change the type of masks that are selectable in the next step
                if (this.value === "unsure") {
                    // open the help step
                    section.querySelector('.productMaskStep[data-type="help"]').classList.add('active');
                } else {
                    // select the type and reopen sections
                    section.querySelectorAll('.productMaskSelectItem')?.forEach(item => {
                        item.dataset.type === this.value
                            ? item.classList.add('active') : item.classList.remove('active');
                    })
                    // open next section
                    section.querySelector('.productMaskStep[data-type="mask"]').classList.add('active');
                    // change warning message next to atc
                    section.querySelector('.productOptionsBottomWarning').textContent = "Choose Mask"
                }

            })
        })

        // mask type selection
        section.querySelectorAll('.productMaskSelectChoice')?.forEach(el => {
            el.addEventListener('change', function () {
                // change the type of masks that are selectable in the next step
                if (this.value === "unsure") {
                    // open the help step
                    section.querySelector('.productMaskStep[data-type="help"]').classList.add('active');
                } else if (this.value !== "") {
                    // use mask choice to update the mask help slide in, the size options, and the image
                    const mask = maskSupplementInfo[this.value];
                    // upload size options onto the select element
                    section.querySelector('.productMaskSizeChoice').innerHTML = `
                    <option value="" disabled selected>Choose a Mask Size</option>
                    `;
                    // add unsure option
                    if (this.classList.contains('unsureOption')) {
                        section.querySelector('.productMaskSizeChoice').insertAdjacentHTML("beforeend", `
                                <option value="unsure">Unsure</option>
                            `)
                    }
                    // add options
                    for (let i = 0; i < mask.variants.length; i++) {
                        section.querySelector('.productMaskSizeChoice').insertAdjacentHTML("beforeend", `
                                <option value="${mask.variants[i].id}">${mask.variants[i].title}</option>
                            `)
                    }
                    // open next section
                    section.querySelector('.productMaskStep[data-type="size"]').classList.add('active');
                    // change warning message next to atc
                    section.querySelector('.productOptionsBottomWarning').textContent = "Choose Mask Size"
                    // upload image
                    if (mask.images[0]) {
                        section.querySelector(`.productMaskSelectContainerImage[data-collection="${mask.collection}"]`).src = mask.images[0] + "&width=100";
                        section.querySelector(`.productMaskSelectButtonIcon[data-collection="${mask.collection}"]`).classList.add('active');

                    } else {
                        section.querySelector('.productMaskSelectContainerImage').src = "#";
                        section.querySelector(`.productMaskSelectButtonIcon[data-collection="${mask.collection}"]`).classList.remove('active');
                    }
                    // extra information slider update
                    if (mask.metadata.info || mask.description) {
                        maskInfoSlideIn(mask);
                        section.querySelector(`.productMaskSelectButton[data-collection="${mask.collection}"]`).disabled = false;
                    } else {
                        section.querySelector(`.productMaskSelectButton[data-collection="${mask.collection}"]`).disabled = true;
                    }
                    // make sure help slide has base info
                    if (mask.metadata.size) {
                        section.querySelector('.productSlideSize .productSlideSectionContent').innerHTML = mask.metadata.size || "N/A";
                    }
                }

            })
        })

        // mask size selection
        section.querySelectorAll('.productMaskSizeChoice')?.forEach(el => {
            el.addEventListener('change', function () {
                if (this.value === "unsure") {
                    // open the help step
                    section.querySelector('.productMaskStep[data-type="help"]').classList.add('active');
                }
                // update the mask size info
                if (section.querySelector('.productMaskSelectItem.active .productMaskSelectChoice').value) {
                    const productInfo = maskSupplementInfo[section.querySelector('.productMaskSelectItem.active .productMaskSelectChoice').value];
                    const variantId = this.value;
                    if (productInfo && productInfo.metadata.size) {
                        section.querySelector('.productSlideSize .productSlideSectionContent').innerHTML = productInfo.metadata.size || "N/A";
                    } else if (productInfo && variantId) {
                        const variantInfo = productInfo.variants.find(variant => variant.id === variantId);
                        section.querySelector('.productSlideSize .productSlideSectionContent').innerHTML = variantInfo.size || "N/A";
                    } else {
                        section.querySelector('.productSlideSize .productSlideSectionContent').innerHTML = "N/A";
                    }
                }
            })
        })
    }

    /******************
     Products with masks
     *******************/

    // if there are image buttons for masks
    if (section.querySelector('.productOptionsItemValuesImagesItem')) {

        // selecting the mask value in selector will show image
        section.querySelector('.productOptionsItemValuesWrap .productOptionsItemValues').addEventListener('change', function () {
            section.querySelectorAll('.productOptionsItemValuesImagesItem')?.forEach(el => {
                el.dataset.value === this.value
                    ? el.classList.add('active') : el.classList.remove('active');
            })
        })

        // clicking image will open slide in with info if available
        section.querySelectorAll('.productOptionsItemValuesImagesItem')?.forEach(el => {
            el.addEventListener('click', function () {
                const mask = maskSupplementInfo[this.dataset.product];

                if (mask.metadata.info || mask.description) {
                    maskInfoSlideIn(mask);
                    // give info time to populate
                    setTimeout(() => {
                        openSlideIn("info");
                    }, 300);
                }
            })
        })
    }

    /********
     Dialogs
     *********/

    // all close buttons
    section.querySelectorAll('.productDialogExit')?.forEach(exit => {
        exit.addEventListener('click', function () {
            this.closest('.productDialog').close();
        })
    })

    // all dialogs close events
    section.querySelectorAll('.productDialog')?.forEach(dialog => {
        // close event
        dialog.addEventListener('close', function () {
            dialog.classList.remove('active');
            document.querySelector('body').classList.remove('noScroll');
        })
        // click close
        dialog.addEventListener('click', function (e) {
            if (e.target === this) this.close();
        })
    })

    // dialogs
    const imageDialog = section.querySelector('.productImage');
    const slideInDialog = section.querySelector('.productSlide');

    // zoom button on the swiper
    section.querySelector('.productVisualSwiperZoom')?.addEventListener('click', function () {
        // find source of selected slide
        const src = productSwiper.slides[productSwiper.activeIndex].querySelector('img')?.src;
        // if a video or no source, do nothing
        if (src) {
            openImageDialog(src);
        }
    })

    // open mask info slide
    section.querySelectorAll('.productMaskSelectButton')?.forEach(button => {
        button.addEventListener('click', function () {
            openSlideIn("info");
        })
    })

    // additional information buttons
    section.querySelectorAll('.productAdditionalButton')?.forEach(button => {
        button.addEventListener('click', function () {
            // type will determine which additional information
            const type = this.dataset.type;
            if (type === 'faq') {
                if (document.querySelector('#faq')) {
                    document.querySelector('#faq').scrollIntoView({
                        behavior: "smooth",
                        block: "start"
                    })
                    // check if there is the features menu exists and account for it
                    if (document.querySelector('.pdpMenuSticky')) {
                        setTimeout(() => {
                            window.scrollBy({
                                behavior: "smooth",
                                top: -document.querySelector('.pdpMenuSticky').offsetHeight
                            });
                        }, 1000)
                    }
                }
                return;
            }
            // ensure there is information added to section
            let infoAvailable = false;
            // reveal pertinent information
            slideInDialog.querySelectorAll('.productSlideSectionContent')?.forEach(section => {
                if (section.dataset.type === type) {
                    section.classList.add('active');
                    infoAvailable = true;
                } else {
                    section.classList.remove('active');
                }
            })
            // if a match found, reveal dialog
            if (infoAvailable) {
                openSlideIn("additional");
            }
        })
    })

    // mask help section
    section.querySelectorAll('.productMaskHelp')?.forEach(button => {
        button.addEventListener('click', function () {
            openSlideIn("mask");
        })
    })

    // mask type section
    section.querySelectorAll('.productMaskTypeHelp')?.forEach(button => {
        button.addEventListener('click', function () {
            section.querySelectorAll('.productSlideType .productSlideSectionContent[data-type]').forEach(item => {
                item.dataset.type === this.dataset.type ? item.classList.add('active') : item.classList.remove('active');
            })
            openSlideIn("type");
        })
    })

    // mask size guide
    section.querySelectorAll('.productOptionsItemLabelGuide')?.forEach(button => {
        button.addEventListener('click', function () {
            if (this.classList.contains('maskPage')) {
                section.querySelectorAll('.productSlideSectionContent').forEach(item => {
                    item.dataset.id === activeVariant.id.toString() ? item.classList.add('active') : item.classList.remove('active');
                })
            }
            openSlideIn("size");
        })
    })

    // bnpl
    section.querySelectorAll('.productBNPL')?.forEach(button => {
        button.addEventListener('click', function () {
            openSlideIn("bnpl");
        })
    })

    // companion product info
    section.querySelectorAll('.productOptionsCompanionImageButton')?.forEach(button => {
        button.addEventListener('click', function () {
            openSlideIn(this.dataset.product);
        })
    })

    function openSlideIn(type) {
        // open relevant area
        slideInDialog.querySelectorAll('.productSlideSection')?.forEach(section => {
            if (section.dataset.type === type) {
                section.classList.add('active');
            } else {
                section.classList.remove('active');
            }
        })
        // open the dialog
        slideInDialog.showModal();
        document.querySelector('body').classList.add('noScroll');
        slideInDialog.classList.add('active');
    }

    function openImageDialog(src) {
        // add and show image on dialog
        section.querySelector('.productImageContainerItem').src = src;
        imageDialog.showModal();
        document.querySelector('body').classList.add('noScroll');
    }

    /**************
     Multi-product Swap
     ***************/

    // buttons reload the template with different products
    document.querySelectorAll(".productOptionsMultiItem")?.forEach(async el => {

        // add listener
        el.addEventListener('click', async function () {
            // if active, current product
            if (this.classList.contains("active")) {
                return;
            }

            // get the handle
            const targetHandle = this.dataset.handle;

            // if not marked as a section reload, reload whole page
            if (!this.closest('.productOptionsMulti').classList.contains('active')) {
                window.location.href = `/products/${targetHandle}`;
                return;
            }

            // save main element
            const main = document.querySelector(`#${sectionID}`);

            // fetch the other page
            await fetchSection(targetHandle, main);

            // re-run JS
            fetchOldScript(main);
        })
    })

    // select change reloads the template with different products
    document.querySelectorAll(".productOptionsMultiItemSelect")?.forEach(async (element) => {

        // add listener
        element.addEventListener("change", async function () {

            // return if value is empty
            if (this.value === "") return;
            // get the handle
            const targetHandle = this.value;

            // if not marked as a section reload, reload whole page
            if (!element.closest('.productOptionsMulti').classList.contains('active')) {
                window.location.href = `/products/${targetHandle}`;
                return;
            }

            // save main element
            const main = document.querySelector(`#${sectionID}`);

            // fetch the other page
            await fetchSection(targetHandle, main);
            // re-run JS
            fetchOldScript(main);
        });
    })

    async function fetchSection(handle, main) {
        const html = await fetch(`/products/${handle}?section_id=${sectionID}`)
            .then(response => response.text())

        // get JUST the <main> element
        const parser = new DOMParser();
        const targetDoc = parser.parseFromString(html, "text/html");
        const mainHTML = targetDoc.querySelector(`#${sectionID}`).innerHTML;

        // update html of main
        main.innerHTML = mainHTML;
    }

    function fetchOldScript(section) {
        Array.from(section.querySelectorAll("script"))
            .forEach(oldScriptEl => {
                const newScriptEl = document.createElement("script");

                Array.from(oldScriptEl.attributes).forEach(attr => {
                    newScriptEl.setAttribute(attr.name, attr.value)
                });

                const scriptText = document.createTextNode(oldScriptEl.innerHTML);
                newScriptEl.appendChild(scriptText);

                oldScriptEl.parentNode.replaceChild(newScriptEl, oldScriptEl);
            });
    }

    /********************
     Compatible Products
     ********************/
    if (section.querySelector('.productVisualCompatible')) {
        // compatible product swipers
        section.querySelectorAll('.productVisualCompatibleGroup').forEach(el => {
            new Swiper(el, {
                slidesPerView: 'auto',
                spaceBetween: 14,
            });
        })

        // change on select variants
        section.querySelectorAll('.productVisualCompatibleGroupSlideSelect')?.forEach(el => {
            el.addEventListener('change', function () {
                this.closest('.productVisualCompatibleGroupSlide').querySelector('.productVisualCompatibleGroupSlideAtc').dataset.variant = this.value;
            })
        })

        // add to cart listener
        section.querySelectorAll('.productVisualCompatibleGroupSlideAtc')?.forEach(atc => {
            atc.addEventListener('click', async function () {

                // add loading animation
                this.classList.add("loading");

                let formData = {
                    items: [{
                        quantity: 1,
                        id: parseInt(this.dataset.variant),
                    }]
                };

                // add product
                await addProduct(formData);

                // remove loading animation
                this.classList.remove("loading");

                // open cart
                await openCart();
            })
        })
    }

    /*************
     Out of stock
     *************/
    // if out of stock, button is added and we use the klaviyo oos function
    if (section.querySelector('.productOptionsOOSInput')) {
        // input will enable button for submit
        section.querySelector('.productOptionsOOSInput').addEventListener('change', function () {
            this.value !== "" ?
                section.querySelector('.productOptionsOOSButton').disabled = false :
                section.querySelector('.productOptionsOOSButton').disabled = true;
        })

        section.querySelector('.productOptionsOOSButton').addEventListener('click', async function () {
            await sendKlaviyoBackInStockRequest(section.querySelector('.productOptionsOOSInput').value, activeVariant.id);
            section.querySelector('.productOptionsOOS').innerHTML = `
                <div class="productOptionsOOSTitle">Email submitted!</div>
                <div class="productOptionsOOSText">You will be notified when this item is back in stock.</div>
`;
        })
    }

}());